import React from 'react';

type TipInputProps = {
  prefix?: string,
  value: string,
  onChange: (value: string) => void,
  onApply: () => void,
  onRemove?: () => void,
  appliedTip?: number,
  isLoading?: boolean,
  disabled?: boolean,
  label?: string,
};

const TipInput = ({
  prefix = '$',
  value,
  onChange,
  onApply,
  onRemove,
  appliedTip = 0,
  isLoading = false,
  disabled = false,
  label = 'Add a Tip',
}: TipInputProps) => {
  const isApplied = appliedTip > 0;

  return (
    <div style={{ marginTop: '16px', marginBottom: '8px', width: '100%' }}>
      <div style={{ fontWeight: '600', fontSize: '14px', color: '#1B1B1B', marginBottom: '8px' }}>
        {label}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '6px 12px',
            backgroundColor: '#fff',
            flex: '1',
            maxWidth: '180px',
          }}
        >
          <span style={{ color: '#888', marginRight: '4px', fontSize: '14px', fontWeight: '500' }}>
            {prefix}
          </span>
          <input
            type="text"
            value={value}
            placeholder="0.00"
            disabled={disabled || isLoading}
            style={{
              border: 'none',
              outline: 'none',
              width: '100%',
              fontSize: '14px',
              color: '#333',
              backgroundColor: 'transparent',
            }}
            onChange={(e) => {
              const val = e.target.value;
              const regex = /^\d*\.?\d{0,2}$/;
              if (regex.test(val) || val === '') {
                onChange(val);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onApply();
              }
            }}
          />
        </div>
        <button
          type="button"
          disabled={disabled || isLoading}
          onClick={onApply}
          style={{
            backgroundColor: '#2563eb',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '7px 16px',
            fontSize: '13px',
            fontWeight: '500',
            cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
            opacity: disabled || isLoading ? 0.7 : 1,
            transition: 'background-color 0.2s',
          }}
        >
          {isLoading ? '...' : (isApplied ? 'Update' : 'Apply')}
        </button>
        {isApplied && onRemove && (
          <button
            type="button"
            disabled={disabled || isLoading}
            onClick={onRemove}
            style={{
              backgroundColor: 'transparent',
              color: '#ef4444',
              border: '1px solid #fca5a5',
              borderRadius: '6px',
              padding: '7px 12px',
              fontSize: '13px',
              fontWeight: '500',
              cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
            }}
          >
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default TipInput;
